export const iconDefaultOffset = 20;
export const iconDefaultSize = 40;
